import React from 'react';
import appStore from 'client/AppStore';
import AssignmentSettingsEditor from 'client/Assignments/AssignmentSettingsEditor/AssignmentSettingsEditor.react';

export default class AssignmentV2Settings extends React.Component {
  render() {
    const examId = appStore.routerProps.params.examId;
    return <AssignmentSettingsEditor assignmentId={examId} type='Assessment' />;
  }
}
